import { render } from "./f-billing.vue?vue&type=template&id=9f2bc932&scoped=true"
import script from "./f-billing.vue?vue&type=script&lang=js"
export * from "./f-billing.vue?vue&type=script&lang=js"

import "./f-billing.vue?vue&type=style&index=0&id=9f2bc932&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2bc932"]])

export default __exports__